<rav-modal [modalId]="'e2eEncryptionModal'" (close)="closeDialog()">
  <h3 class="text-capitalize">{{ modalText.action }} End-to-End Document Encryption</h3>
  <form
    (ngSubmit)="
      isEnable
        ? disableDocumentEncryption(e2eEncryptionFormGroup.value)
        : enableDocumentEncryption(e2eEncryptionFormGroup.value)
    "
    [formGroup]="e2eEncryptionFormGroup"
    (change)="formUpdated()"
  >
    <div>
      <div class="alert callout margin-top-2">
        <div class="cell small-12 margin-bottom-1"><i class="fa fa-exclamation-triangle"></i> WARNING</div>
        <div class="grid-x" *ngFor="let itemText of modalText?.featureTerms; index as i">
          <div class="cell small-1 text-right">
            <input
              type="checkbox"
              id="{{ 'box' + i }}"
              formControlName="{{ 'box' + i }}"
              name="{{ 'box' + i }}"
              value="{{ 'box' + i }}"
              class="margin-right-1"
            />
          </div>
          <div class="cell small-11">
            <label for="{{ 'box' + i }}" class="margin-bottom-1">
              {{ itemText }}
            </label>
          </div>
        </div>
      </div>
      <h5>
        To proceed with {{ modalText.action2 }} document encryption, please enter your Raven Cloud password below.
      </h5>
      <rav-input [controlFormGroup]="e2eEncryptionFormGroup" controlName="password" (input)="formUpdated()"></rav-input>
    </div>

    <div *ngIf="display2FAForm" class="cell auto">
      <div>
        <h3>{{ useBackupCode ? 'Enter the Backup Code' : 'Enter the Verification Code' }}</h3>
        <div class="padding-top-2" [class.form__error-msg]="errorMessage">
          <h5>{{ useBackupCode ? 'Enter one of your 10-digit backup code' : twoFARequest.message }}</h5>

          <rav-input
            [controlFormGroup]="e2eEncryptionFormGroup"
            [class.is-invalid-input]="errorMessage"
            placeholder="{{ useBackupCode ? 'Enter the 10 digit code' : 'Enter the 6 digit code' }}"
            data-cy="verification_code"
            controlName="verification_code"
          ></rav-input>
          {{ errorMessage }}
        </div>
        <a *ngIf="twoFARequest.method !== TwoFactorMethod.APP" (click)="twoFaLogin(e2eEncryptionFormGroup.value)"
          >Resend Verification code</a
        >
        <a [class.align-right]="twoFARequest.method !== TwoFactorMethod.APP" (click)="useBackupCode = !useBackupCode">
          {{ useBackupCode ? 'Use Verification Code' : 'Use Backup Code' }}
        </a>
      </div>
    </div>
    <p class="form-error" *ngIf="error">{{ error }}</p>

    <button
      *ngIf="!containsInvalidUsers"
      type="submit"
      [disabled]="!e2eEncryptionFormGroup.valid || isProcessing"
      class="button button margin-right-1"
    >
      {{ modalText.action }}
    </button>
    <button *ngIf="containsInvalidUsers" (click)="sendNoticeAction()" class="button button margin-right-1">
      Send Notice
    </button>
    <button type="button" class="hollow button" (click)="closeDialog()">Cancel</button>
    <div class="loading" *ngIf="isProcessing">
      <img class="loader__image" src="/assets/images/loading.gif" alt="Loading spinner" />
    </div>
  </form>
</rav-modal>
